import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MenuItems } from '../../../core/shared/menu-items/menu-items';
import { TranslationService } from '../../../core/services/translation/translation.service';
import { Router } from '@angular/router';
import { AgenceService } from '../../../core/services/agence/agence.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { UserService } from '../../../core/services/user/user.service';
import { UserOptions } from 'jspdf-autotable';
import jsPDF from 'jspdf';
import { CollisService } from '../../../core/services/collis/collis.service';
import { HttpClient } from '@angular/common/http';
import { ColissessionService } from '../../../core/services/colissession/colissession.service';
import { DatePipe } from '@angular/common';
import { BagageService } from '../../../core/services/bagage/bagage.service';
import { RecetteService } from '../../../core/services/recette/recette.service';
import { MenuItemsGuichet } from '../../../core/shared/menu-items/menu-item-guichet';
import { MenuItemsEnvoi } from 'src/app/core/shared/menu-items/menu-item-envoi';
import { MenuItemsChef } from '../../../core/shared/menu-items/menu-item-chef';
import { MenuItemsRetrait } from 'src/app/core/shared/menu-items/menu-item-retrait';
import { MenuItemsAccounting } from 'src/app/core/shared/menu-items/menu-item-accounting';
import { MenuItemsFiscalite } from '../../../core/shared/menu-items/menu-item-fiscalite';
import { MenuItemsChefCourrier } from '../../../core/shared/menu-items/menu-item-chefcourrier';
import { MenuItemsDispatching } from '../../../core/shared/menu-items/menu-item-dispatching';
import { VoyageService } from '../../../core/services/voyage/voyage.service';
import { ProfileComponent } from 'src/app/module/account/profile/profile.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ImageCacheService } from 'src/app/core/services/image/image-cache.service';
import { SessionCloseService } from 'src/app/core/services/session/session-close.service';
import { SessionPrintService } from 'src/app/core/services/print/session-print.service';
import Swal from 'sweetalert2';

interface jsPDFWithPlugin extends jsPDF {
  autoTable: (options: UserOptions) => jsPDF;
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: []
})
export class AppSidebarComponent implements OnDestroy, OnInit {
  mobileQuery: MediaQueryList;

  private _mobileQueryListener: () => void;
  userinfo: any;
  userprivileges: any;
  picture: any;
  collis: any;
  base64: any;
  sessiondetail: any;
  name: string;
  depense: any;
  pageheight: any;
  recette: any;
  bagage: any;
  get section(): string | null {
    return localStorage.getItem('section');
  }
  ispopup: boolean;
  pageHeights3: any;
  pageHeights2: any;
  profileImageBase64: string | null = null;
  backgroundImageBase64: string | null = null;

  constructor(
    private changeDetectorRef: ChangeDetectorRef, private dialog: MatDialog,
    private media: MediaMatcher, private translationservice: TranslationService,
    public menuItems: MenuItems, public menuItems2: MenuItemsGuichet, public menuItems3: MenuItemsEnvoi,
    public menuItems4: MenuItemsChef, public menuItems5: MenuItemsRetrait, public menuItemsAccounting: MenuItemsAccounting,
    public menuItemsFiscalite: MenuItemsFiscalite, public menuItemsChefCourrier: MenuItemsChefCourrier,
    public menuItemsDispatching: MenuItemsDispatching, private router: Router,
    private agenceservice: AgenceService, private bnIdle: BnNgIdleService, private userservice: UserService,
    private collisservice: CollisService, private http: HttpClient, private sessionservice: ColissessionService,
    private datepipe: DatePipe, private bagageservice: BagageService, private recetteservice: RecetteService,
    private voaygeservice: VoyageService,
    private imageCacheService: ImageCacheService,
    private sessionCloseService: SessionCloseService,
    private sessionPrintService: SessionPrintService
  ) {
    // this.section = localStorage.getItem('section');
    this.getuserinfo();
    this.mobileQuery = media.matchMedia('(min-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.userprivileges = localStorage.getItem('authority');
    this.userprivileges = JSON.parse(this.userprivileges);
    let personid: any = localStorage.getItem('userinfo');
    personid = JSON.parse(personid);
    this.name = personid[0].nom + ' ' + personid[0].prenom;
    this.picture = personid[0].profile;
    this.ispopup = false;
  }
  ngOnInit(): void {
    const auth = localStorage.getItem('authority');
    if (auth) {
      try {
        this.userprivileges = JSON.parse(auth);
      } catch {}
    }
    this.getuserinfo();
    this.getlogo();
    this.loadProfileImage();
    this.loadSidebarImages();
  }

  loadProfileImage(): void {
    this.imageCacheService
      .getImage('assets/images/profile.jpg')
      .subscribe({
        next: (base64: string) => {
          this.profileImageBase64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading profile image:', error);
          // Fallback to direct path will be used via template binding
        }
      });
  }

  loadSidebarImages(): void {
    this.imageCacheService.getImage('assets/images/background/user-info.jpg').subscribe({
      next: (base64: string) => {
        this.backgroundImageBase64 = base64;
      },
      error: (error: any) => {
        console.error('Error loading background image:', error);
      }
    });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }


  viewProfil(): any {

    this.ispopup = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {};
    const dialogref = this.dialog.open(ProfileComponent, {
      width: 'auto', height: 'auto', autoFocus: true, disableClose: dialogConfig.disableClose, data: {}
    });
  }

  logout(): void {
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('session');
    localStorage.removeItem('authority');
    localStorage.removeItem('lastprint');
    localStorage.removeItem('voyage');
    this.router.navigateByUrl('login');
    localStorage.removeItem('voyage');
  }

  hasPrivilege(privCode: string): boolean {
    const userRole = (localStorage.getItem('userRole') || '').toUpperCase();
    const section = (localStorage.getItem('section') || '').toUpperCase();
    if (userRole.includes('ADMIN') || userRole === 'ADM' || section === 'ADMIN') {
      return true;
    }
    if (!this.userprivileges) {
      const auth = localStorage.getItem('authority');
      if (auth) {
        try {
          this.userprivileges = JSON.parse(auth);
        } catch {}
      }
    }
    if (!this.userprivileges) return false;
    for (let i = 0; i < this.userprivileges.length; i++) {
      if (this.userprivileges[i]?.privileges && this.userprivileges[i].privileges.codepriv === privCode && this.userprivileges[i].state) {
        return true;
      }
    }
    return false;
  }

  closesession(): void {
    Swal.fire({
      title: 'Fermer la session',
      text: 'Voulez-vous vraiment fermer votre session ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, fermer',
      cancelButtonText: 'Annuler'
    }).then((result: any) => {
      if (result.isConfirmed) {
        let personid: any = localStorage.getItem('userinfo');
        personid = JSON.parse(personid);
        const sessionid = '';
        const session = localStorage.getItem('session');

        this.userservice.updateusersession(personid[0].idpersonnel, sessionid, session).subscribe(
          (response: any) => {
            this.getsessioninfoBeforeCloseSession(session);
          },
          (error: any) => {
            console.error('update session error', error);
            Swal.fire({
              title: 'Erreur',
              text: 'Une erreur s\'est produite lors de la fermeture de la session.',
              icon: 'error',
              confirmButtonText: 'OK'
            }).then(() => {
              this.getsessioninfoBeforeCloseSession(session);
            });
          }
        );
      }
    });
  }

  getuserinfo(): any {
    this.userinfo = localStorage.getItem('userinfo');
    this.userinfo = JSON.parse(this.userinfo);
    this.userinfo = this.userinfo[0];
    localStorage.setItem('agence', this.userinfo?.idagence);
    this.getagenceinfo();
  }

  getagenceinfo(): any {
    this.agenceservice.getagenceinfo(localStorage.getItem('agence')).subscribe((response: any) => {
      const agenceinfo = JSON.stringify(response);
      localStorage.setItem('agenceinso', agenceinfo);
    });
  }

  decodeuri(uri: string): string {
    return decodeURIComponent(uri);
  }

  async print(session: any): Promise<any> {
    if (this.sessiondetail) {
      this.sessiondetail.sessionCount = this.sessiondetail.sessionCount || 1;
      this.sessiondetail.name = this.name;
    }
    await this.sessionPrintService.printColisSession(this.sessiondetail || session);
    setTimeout(() => {
      this.clearSessionAndLogout();
    }, 300);
  }

  private clearSessionAndLogout() {
    localStorage.removeItem('userinfo');
    localStorage.removeItem('token');
    localStorage.removeItem('loggedInUser');
    localStorage.removeItem('userRole');
    localStorage.removeItem('agenceinso');
    localStorage.removeItem('agence');
    localStorage.removeItem('session');
    localStorage.removeItem('authority');
    localStorage.removeItem('lastprint');
    localStorage.removeItem('section');
    this.router.navigateByUrl('login');
    // Note: session is removed in closesession explicitly via updateusersession
  }

  async getlogo(): Promise<any> {
    // Use image cache service for non-blocking, cached image loading
    this.imageCacheService
      .getImage('../../../../assets/images/logogen.jpg')
      .subscribe({
        next: (base64: string) => {
          this.base64 = base64;
        },
        error: (error: any) => {
          console.error('Error loading logo:', error);
        }
      });
  }

  getsessioninfo(session: any): any {
    this.sessionservice.getsessiondetail(session).subscribe((response: any) => {
      this.sessiondetail = response;
    });
  }
  getsessioninfoBeforeCloseSession(session: any): any {
    this.sessionCloseService.closeSession(session, this.name, this.base64);
  }

}